
/**
 * Drag Scroll Handler - Shared utility for mouse drag scrolling
 * Provides horizontal drag scrolling functionality for containers
 */
class DragScrollHandler {
  constructor(container, options = {}) {
    this.container = container;
    this.options = {
      scrollAmount: options.scrollAmount || 1,
      enableVertical: options.enableVertical || false,
      ...options
    };
    
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.scrollLeft = 0;
    this.scrollTop = 0;
    
    this.init();
  }

  init() {
    if (!this.container) {
      console.warn('DragScrollHandler: Container not found');
      return;
    }

    this.bindEvents();
    this.setupStyles();
    console.log('DragScrollHandler: Initialized for container', this.container);
  }

  bindEvents() {
    // Mouse events
    this.container.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.container.addEventListener('mousemove', this.handleMouseMove.bind(this));
    this.container.addEventListener('mouseup', this.handleMouseUp.bind(this));
    this.container.addEventListener('mouseleave', this.handleMouseUp.bind(this));

    // Prevent default drag behavior on images and links
    this.container.addEventListener('dragstart', (e) => e.preventDefault());
  }

  setupStyles() {
    // Add grab cursor when not dragging
    this.container.style.cursor = 'grab';
    this.container.style.userSelect = 'none';
  }

  handleMouseDown(e) {
    // Only handle left mouse button
    if (e.button !== 0) return;

    this.isDragging = true;
    this.startX = e.pageX - this.container.offsetLeft;
    this.startY = e.pageY - this.container.offsetTop;
    this.scrollLeft = this.container.scrollLeft;
    this.scrollTop = this.container.scrollTop;

    this.container.style.cursor = 'grabbing';
    e.preventDefault();

    console.log('DragScrollHandler: Started dragging');
  }

  handleMouseMove(e) {
    if (!this.isDragging) return;

    const x = e.pageX - this.container.offsetLeft;
    const y = e.pageY - this.container.offsetTop;
    const walkX = (x - this.startX) * this.options.scrollAmount;
    const walkY = (y - this.startY) * this.options.scrollAmount;

    this.container.scrollLeft = this.scrollLeft - walkX;
    
    if (this.options.enableVertical) {
      this.container.scrollTop = this.scrollTop - walkY;
    }

    e.preventDefault();
  }

  handleMouseUp(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.container.style.cursor = 'grab';

    console.log('DragScrollHandler: Stopped dragging');
  }

  // Public method to destroy the handler
  destroy() {
    if (!this.container) return;

    this.container.removeEventListener('mousedown', this.handleMouseDown);
    this.container.removeEventListener('mousemove', this.handleMouseMove);
    this.container.removeEventListener('mouseup', this.handleMouseUp);
    this.container.removeEventListener('mouseleave', this.handleMouseUp);
    this.container.removeEventListener('dragstart', (e) => e.preventDefault());

    this.container.style.cursor = '';
    this.container.style.userSelect = '';

    console.log('DragScrollHandler: Destroyed');
  }
}

// Export for use in other modules
if (typeof window !== 'undefined') {
  window.DragScrollHandler = DragScrollHandler;
}
